import { useContext, useEffect, useState } from 'react';
import { MyContext } from '../../context';
import DataTable from '../../components/tables/DataTable';
import Pagination from '../../components/Pagination';
import StatusBadge from '../../components/StatusBadge';
import SimpleDropdown from '../../components/SimpleDropdown';
import { listCommerceEvents } from '../../utils/queries';
import { COMMERCE_EVENT_TYPES } from '../../utils/commerceEventTypes';

const PAGE_SIZE = 25;

const BADGE_BY_PREFIX = {
	order: 'processing',
	payment: 'pending',
	inventory: 'backorder',
	customer: 'approval',
	product: 'active',
};

export default function EventLog() {
	const { activeStoreId } = useContext(MyContext);
	const [eventType, setEventType] = useState('');
	const [events, setEvents] = useState([]);
	const [total, setTotal] = useState(0);
	const [page, setPage] = useState(0);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		setLoading(true);
		listCommerceEvents({
			limit: PAGE_SIZE,
			offset: page * PAGE_SIZE,
			storeId: activeStoreId || undefined,
			eventType: eventType || undefined,
		}).then((result) => {
			if (result?.success) {
				setEvents(result.data.events);
				setTotal(result.data.pagination.total);
			}
			setLoading(false);
		});
	}, [page, activeStoreId, eventType]);

	const columns = [
		{
			key: 'eventType',
			header: 'Event',
			render: (value) => (
				<StatusBadge status={BADGE_BY_PREFIX[String(value).split('.')[0]] || 'unknown'} text={value} />
			),
		},
		{ key: 'entityType', header: 'Entity' },
		{ key: 'entityId', header: 'Entity ID' },
		{ key: 'mode', header: 'Mode' },
		{
			key: 'occurredAt',
			header: 'When',
			render: (value) => (value ? new Date(value).toLocaleString() : ''),
		},
	];

	return (
		<div className='py-8 pr-8'>
			<h1 className='text-2xl font-light tracking-tight mb-2'>Event Log</h1>
			<p className='text-sm text-gray-500 mb-6'>
				Every commerce event this store has recorded, independent of whether any webhook is currently
				subscribed to it.
			</p>

			<div className='mb-4 w-64'>
				<SimpleDropdown
					value={eventType}
					onChange={(v) => {
						setPage(0);
						setEventType(v);
					}}
					options={[{ value: '', label: 'All event types' }, ...COMMERCE_EVENT_TYPES.map((t) => ({ value: t, label: t }))]}
				/>
			</div>

			<DataTable columns={columns} data={events} loading={loading} emptyHeading='No events recorded yet' />
			<Pagination pageCount={Math.ceil(total / PAGE_SIZE)} currentPage={page} onPageChange={setPage} />
		</div>
	);
}
